import 'edge/guidance/common/app';
import 'edge/addresslookup/app';

export default angular.module('edge.guidance.app', ['edge.guidance.common.app', 'edge.addresslookup.app']);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/app.js
// module id = 953
// module chunks = 0